import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { CATEGORY_META } from "@/i18n/translations";
import VerifiedBadge from "@/components/VerifiedBadge";

export default function ListingCard({ listing, index = 0 }) {
  const { lang, L, t } = useLang();
  const cat = CATEGORY_META[listing.category];
  const catLabel = cat ? cat[lang] : listing.category;

  return (
    <Link
      to={`/listing/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      className="group flex flex-col border border-tertiary bg-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] animate-fade-up"
      style={{ animationDelay: `${Math.min(index * 60, 360)}ms` }}
    >
      {listing.cover_image ? (
        <div className="relative aspect-[16/10] overflow-hidden bg-sand">
          <img
            src={listing.cover_image}
            alt={L(listing, "title")}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
            loading="lazy"
          />
        </div>
      ) : (
        <div className="aspect-[16/10] bg-gradient-to-br from-sand to-tertiary" />
      )}
      <div className="flex flex-1 flex-col p-6">
        <div className="mb-3 flex items-center justify-between gap-2">
          <span className="text-xs uppercase tracking-[0.2em] text-champagne">{catLabel}</span>
          <VerifiedBadge verified={listing.rst_verified} />
        </div>
        <h3 className="mb-2 font-serif text-xl leading-snug text-anthracite">{L(listing, "title")}</h3>
        <p className="mb-4 flex-1 text-sm leading-relaxed text-anthracite/70 line-clamp-3">{L(listing, "summary")}</p>
        <div className="flex items-center justify-between border-t border-tertiary pt-4">
          <span className="flex items-center gap-1.5 text-xs text-anthracite/50">
            {(listing.country || listing.sector) && <MapPin className="h-3.5 w-3.5" strokeWidth={1.5} />}
            {[listing.sector, listing.country].filter(Boolean).join(" · ")}
          </span>
          <span className="flex items-center gap-1 text-xs font-medium text-anthracite opacity-0 transition-opacity group-hover:opacity-100">
            {t("cta_view_detail")} <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={1.75} />
          </span>
        </div>
      </div>
    </Link>
  );
}
